function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("g", null, React.createElement("path", {
  d: "M507.604,4.397c-5.863-5.863-15.351-5.863-21.214,0L452.429,38.36c-16.697-7.897-37.081-5.347-50.892,8.465 c-17.573,17.573-17.573,46.066,0,63.638c17.574,17.574,46.068,17.574,63.64,0c13.812-13.812,16.362-34.191,8.465-50.891 l33.962-33.962C513.465,19.749,513.465,10.26,507.604,4.397z"
})));

var _ref3 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("g", null, React.createElement("path", {
  d: "M231.834,407.449l-63.64-63.64l-63.64-63.64c-5.864-5.863-15.351-5.863-21.214,0 c-37.304,37.304-40.217,95.726-9.534,136.815L4.397,486.391c-5.861,5.863-5.861,15.352,0,21.213 c5.863,5.863,15.352,5.863,21.215,0l69.407-69.408c41.089,30.683,99.51,27.77,136.815-9.534 C237.695,422.799,237.695,413.31,231.834,407.449z"
})));

var _ref4 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("g", null, React.createElement("path", {
  d: "M443.965,152.89l-42.427-42.427l-42.426-42.426c-5.864-5.863-15.35-5.863-21.214,0L316.686,89.25 c-5.863,5.863-5.863,15.35,0,21.213l84.851,84.853c5.863,5.863,15.352,5.863,21.215,0l21.213-21.213 C449.828,168.24,449.828,158.753,443.965,152.89z"
})));

var _ref5 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("g", null, React.createElement("circle", {
  cx: 327.29,
  cy: 184.71,
  r: 45
})));

var _ref6 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("g", null, React.createElement("path", {
  d: "M337.896,258.954l-42.427-42.427l-42.426-42.426c-17.572-17.572-46.063-17.572-63.638,0.002 c-17.573,17.574-17.573,46.066,0,63.64l4.05,4.05L152.84,255.33c-5.841,1.948-9.891,7.26-10.234,13.403 c-0.103,1.926-2.267,47.223,25.585,75.075c27.852,27.852,73.149,25.688,75.075,25.583c6.141-0.341,11.455-4.391,13.403-10.234 l13.537-40.613l4.05,4.05c17.574,17.573,46.066,17.573,63.64,0C355.469,305.02,355.469,276.526,337.896,258.954z"
})));

var _ref7 =
/*#__PURE__*/
React.createElement("g", null);

var _ref8 =
/*#__PURE__*/
React.createElement("g", null);

var _ref9 =
/*#__PURE__*/
React.createElement("g", null);

var _ref10 =
/*#__PURE__*/
React.createElement("g", null);

var _ref11 =
/*#__PURE__*/
React.createElement("g", null);

var _ref12 =
/*#__PURE__*/
React.createElement("g", null);

var _ref13 =
/*#__PURE__*/
React.createElement("g", null);

var _ref14 =
/*#__PURE__*/
React.createElement("g", null);

var _ref15 =
/*#__PURE__*/
React.createElement("g", null);

var _ref16 =
/*#__PURE__*/
React.createElement("g", null);

var _ref17 =
/*#__PURE__*/
React.createElement("g", null);

var _ref18 =
/*#__PURE__*/
React.createElement("g", null);

var _ref19 =
/*#__PURE__*/
React.createElement("g", null);

var _ref20 =
/*#__PURE__*/
React.createElement("g", null);

var _ref21 =
/*#__PURE__*/
React.createElement("g", null);

var SvgEspetos = function SvgEspetos(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512.001 512.001",
    style: {
      enableBackground: "new 0 0 512.001 512.001"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgEspetos, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/espetos.f7738e67.svg";
export { ForwardRef as ReactComponent };